import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FULFILLED_BY_IMG,
  VIEWALL_IMG
} from "../../../../../constants/Constant";
import Spinner from "../../../../../utils/Spinner";

const SchemaCardView = (props) => {
  const { title, schema } = props;

  return (
    <>
      {(schema?.schemaLoading) ? (<div className="justify-content-md-center">
        {" "}
        <Spinner
          text="Schemas"
        />
      </div>) : (
        <>
          <div className="datasets__type__header pt-3">
            <div className="sub__header">
              {" "}
              <span className="do__bu__tag">
                {" "}
                {title} ({schema?.schemaAllData.length})
              </span>
            </div>

            <h2 className="view__spacing">
              <Link to="/databook/viewallschemas" state={schema?.schemaAllData}>
                <Button className="view__all__data">
                  <img src={VIEWALL_IMG} alt="View All icon" />
                  <span>View All</span>
                </Button>
              </Link>
            </h2>
          </div>

          <Row className="gy-3 pt-3 biz-dom-wrap py-4">
            {schema?.schemadata.map((sch, index) => {
              return (
                <Col xs={12} sm={6} md={6} lg={4} xl={2} xxl={2} key={index}>
                  {" "}
                  <Link to={`/databook/schema/${props.tag}/${sch}`} className="widg__f">
                    <Card className="shadow-none border rounded-1 text-center h-100">
                      <Card.Body className="bg-transparent rounded-1">
                        <div className="main__b">
                          {/* <span role="img" className="dataset_img_b">
                            <img src={FULFILLED_BY_IMG} alt="Datasets" />
                          </span>
                          <div className="sub__b">
                            <span className="data__stan__name">{sch}</span>
                          </div> */}
                        <div>
                          <div className="card_label_full"><span className="bd__name text-wrap">{sch}</span></div>
                        </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              );
            })}
          </Row>
        </>
      )}

    </>
  );
};

export default SchemaCardView;
